<form [formGroup]="control()" novalidate class="ap-personal-details ap-grid ap-grid-cols-1 ap-gap-2 ap-gap-gt-sm-3 ap-grid-margin-fix">
    <ap-radio-group
        [inline]="true"
        [control]="control().controls['gender']"
        [messages]="genderErrorMessages"
        data-testid="gender"
        [description]="'personal.details.limited.gender.label' | apContent"
        [descriptionHidden]="true"
    >
        @for (option of genderOptions; track option) {
            <ap-radio-button
                [label]="option.content | apKeyOverride: contentKeyMap() | apContent"
                [value]="option.value"
                [formControl]="control().controls['gender']"
                name="gender"
                data-testid="gender-button"
            >
            </ap-radio-button>
        }
    </ap-radio-group>
    <div class="ap-grid ap-grid-cols-1 ap-grid-cols-gt-sm-4 ap-gap-2 ap-gap-gt-sm-5">
        <ap-initials-input
            [label]="'personal.details.limited.initials.label' | apKeyOverride: contentKeyMap() | apContent"
            name="initials"
            [messages]="initialsErrorMessages"
            [formControl]="control().controls['initials'] | apFormControl"
            data-testid="initials"
        >
        </ap-initials-input>
        <ap-input
            [label]="'personal.details.limited.insertion.label' | apKeyOverride: contentKeyMap() | apContent"
            name="insertion"
            autocomplete="additional-name"
            [formControl]="control().controls['insertion'] | apFormControl"
            [messages]="insertionErrorMessages"
            data-testid="insertion"
        >
        </ap-input>
        <ap-input
            [label]="'personal.details.limited.lastName.label' | apKeyOverride: contentKeyMap() | apContent"
            name="lastName"
            autocomplete="family-name"
            (hasDiacritics)="diacriticsChange($event)"
            apDiacriticsNormalizeFormValue
            [formControl]="control().controls['lastName'] | apFormControl"
            [messages]="lastNameErrorMessages"
            data-testid="lastName"
            class="ap-col-span-gt-sm-2"
        >
        </ap-input>
    </div>
    @if (lastNameHasDiacritics) {
        <ap-notification data-bb="diacritic-notification" status="warning">
            <ap-content
                [params]="{ lastName: getLastName() }"
                key="{{ 'personal.details.limited.diacritics.message' | apKeyOverride: contentKeyMap() }}"
            ></ap-content>
        </ap-notification>
    }
</form>
